import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const SearchInput = styled.input`
    background: transparent;
    border: none;
    color: ${theme.colors.foreground.default};
    flex: 1;
    font-size: ${theme.fontSizes[14]};
    line-height: 24px;
    min-width: 0;
    outline: none;
    padding: 0;

    &::placeholder {
        color: ${theme.colors.foreground.subtle};
    }

    &:disabled {
        color: ${theme.colors.foreground.disabled};
    }

    &:disabled::placeholder {
        color: ${theme.colors.foreground.disabled};
    }
`;
